module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rRWEDJ/images/cover.jpg?1684988648293",
      "alt": "This image is the cover for the book Sunday Comes Every Week"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sunday Comes Every Week\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("Seasoned advice for pastors facing the weekly challenge of preparing sermons")])]), _c('p', [_vm._v("For pastors, a new sermon comes every week. Conventional wisdom says that pastors need to sequester themselves to prepare their weekly sermon without distraction. But veteran preacher Frank Honeycutt suggests just the opposite: prepare your sermons as part of a daily, lived experience in the community.")]), _c('p', [_vm._v("Using the days of the week as a framework, Honeycutt describes practical and essential tasks leading up to the writing and delivery of the Sunday sermon—habits that will provide lasting spiritual nourishment for pastors who plan for a long career in parish ministry. With humor and candid acknowledgment of his own mistakes and doubts, Honeycutt reflects on the joys and hazards of ministry and explains how a faithful process of preaching shapes pastors for a lifetime of healthy ministry.")]), _vm._v("Monday: ListeningTuesday: HearingWednesday: ExegetingThursday: NamingReflecting: A Pastor Looks BackFriday: WritingSaturday: RehearsingSunday: Offering\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frank G. Honeycutt, Thomas G. Long\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0